import {Component, Input} from "@angular/core";

/**
 * A component that renders an SVG icon for "Security"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-security',
    templateUrl: './icon-security.component.html',
    styleUrls: ['./icon-security.component.scss'],
    standalone: false
})
export class IconSecurityComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
